export default __webpack_public_path__ + "static/media/fasting_veggies@3x.2bfb2f64.jpg";